import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

import { Question, QuestionType } from '@empathy/survey/base';

@Component({
  selector: 'empathy-error-container',
  templateUrl: 'error-container.component.html',
  styleUrls: ['./error-container.component.scss']
})
export class ErrorContainerComponent {
  @Input() question: Question;
  @Input() questionCtrl: AbstractControl;

  questionType = QuestionType;
}
